export default __webpack_public_path__ + "static/media/Path3394.276a166a.svg";